<template>
  <div style="width:257px">
    <!-- <treeselect 
			v-model="value" 
			:multiple="true" 
			:options="options.map(el => ({
				value: el.branch_id,
				id:el.branch_id, label: el.branch_name_en
			}))"
			:limit="1"
			:limitTex="20"	
			:placeholder="$t('filter_by_branch')"
			@input="input"
    />-->
    <a-select
      v-model="value"
      showSearch
      :mode="multiple ? 'multiple' : 'default'"
      style="width: 98%"
      optionFilterProp="children"
      :maxTagTextLength="17"
      :maxTagCount="1"
      :placeholder="$t('filter_by_branch')"
      :options="
        options.map(el => ({
          value: el.branch_id,
          id: el.branch_id,
          label: el.branch_name_en
        }))
      "
      :filterOption="
        (input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
      "
      @change="changeValue"
    />
  </div>
</template>

<script>
export default {
  name: 'branchFilter',
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      value: [],
      options: []
    }
  },
  created() {
    this.fetchBranch()
  },
  methods: {
    fetchBranch() {
      this.$store
        .dispatch('branch/fetch', {
          page: -1,
          fields: {
            setup_branch_profiles: 'branch_id,branch_name_en'
          },
          filter: {
            user_branches: 1
          }
        })
        .then(response => {
          this.options = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    changeValue() {
      this.$emit('filter', this.value)
    }
  }
}
</script>
<style lang="css" scoped>
.vue-treeselect__control {
  height: 34px !important;
}
</style>
